import React from 'react'
import * as E from './checklistCardElements'
import CardChecklistItem from './cardChecklistItem'
import { ICardSectionBlockProps } from './proposalInterfaces/cardSectionBlockProps'
import { ICardChecklistItemProps } from './proposalInterfaces/cardCheckListItemProps'

const CardSectionBlock = (props: ICardSectionBlockProps) => {
  return (
    <>
      <div>
        {props.sectionBlock.heading && (
          <E.SubHeading>{props.sectionBlock.heading}</E.SubHeading>
        )}
      </div>
      <div>
        {props.sectionBlock.checklistItems.map(
          (ci: ICardChecklistItemProps) => (
            <CardChecklistItem
              cardNumber={props.cardNumber}
              showIds={props.sectionBlock.showIds}
              item={ci}
              UpdateChecked={props.UpdateChecked}
              errorList={props.errorList}
              theme={props.theme}
            />
          )
        )}
      </div>
    </>
  )
}

export default CardSectionBlock
